import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MutationButton from '../buttons/MutationButton';
import { extendedMutationType } from '../../types';

BidsPlaceBidButton.propTypes = {
    extendedMutation: extendedMutationType.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

function BidsPlaceBidButton(props) {
    const {
        extendedMutation,
        label,
        disabled = false,
    } = props;
    const { t } = useTranslation();
    return (
        <MutationButton
            className="place-bid-button button button-filled"
            confirmationMessage={t('auctions.bids-list.place-bid.confirm-place-bid')}
            disabled={disabled}
            extendedMutation={extendedMutation}
        >
            <FontAwesomeIcon icon="check" />&nbsp;{label}
        </MutationButton>
    );
}

export default BidsPlaceBidButton;
